var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { TimeElapsedPipe, TimeUnitPipe } from './pipes/index';
import { ToneListComponent } from './tone_list/tone-list.component';
import { ToneEntryComponent } from './tone_list/tone_entry/tone-entry.component';
import { routing } from './app.routing';
import { RouterModule } from '@angular/router';
import { AppBus } from './app_bus/app-bus';
export let AppModule = class AppModule {
};
AppModule = __decorate([
    NgModule({
        imports: [
            BrowserModule,
            FormsModule,
            RouterModule,
            routing
        ],
        declarations: [
            AppComponent,
            TimeElapsedPipe,
            TimeUnitPipe,
            ToneListComponent,
            ToneEntryComponent,
        ],
        providers: [
            AppBus
        ],
        bootstrap: [AppComponent],
    }), 
    __metadata('design:paramtypes', [])
], AppModule);
//# sourceMappingURL=app.module.js.map